<app-hero image="hero/hero_access.png" title="Comment venir ?">
  <span>Et ou dormir ?</span>
</app-hero>
<div class="container-flex">
    <div class="row ps-lg-4 align-items-center content-container">
        <div class="col-12 col-lg-5 col-xl-4 col-xxl-3 map-container">
            <div id="map"></div>
        </div>
        <div class="col-10 col-lg-6 offset-2 offset-lg-1 col-xl-7 col-xxl-8 italic address-container mt-5">
            <h1>
                <i class="bi bi-card-heading me-2"></i>
                Adresse
            </h1>
            <div class="address bold">
                Chateau de Granoupiac, 34725 Saint André de Sangonis
                <br />
                <a
                    href="https://ul.waze.com/ul?ll=43.64531463%2C3.52236271&navigate=yes&zoom=16&utm_campaign=default&utm_source=waze_website&utm_medium=lm_share_location">
                    <img class="icon mt-2" src="waze-brands-solid.svg" alt="waze icon">
                </a>
                <a href="https://maps.app.goo.gl/zML3GuQsv9v5ATuF9">
                    <img class="icon mt-2" src="openstreetmap-brands-solid.svg" alt="maps icon">
                </a>
            </div>
            <img class="separator mt-4 mb-2" src="spot-separator.png" alt="separator" width="1000">
            <h1 class="mt-2">
                <i class="bi bi-car-front-fill me-2"></i>
                Comment venir ?
            </h1>
            <ul>
                <li>
                    <span class="bold fs20">En voiture</span>
                    <ul>
                        <li>depuis Montpellier (Environ 35 min) : Prendre A750</li>
                        <li>depuis Nimes (Environ 1h10) : Prendre l’A9 - A709 puis A750</li>
                        <li>depuis Frontignan (Environ 45 min) : Prendre A9 puis A750 ou D463878</li>
                        <li>Depuis le Nord : A75 puis A750</li>
                    </ul>
                </li>
                <li>
                    <span class="bold fs20">A pied ou en vélo</span>
                    <ul>
                        <li>Vous êtes de grands malades!</li>
                    </ul>
                </li>
            </ul>
        </div>
        <img class="separator2 mt-2 mb-2" src="spot-separator.png" alt="separator" width="1000">
        <div class="col-10 offset-2 italic hotel-container">
            <h1 class="mt-2">
                <i class="bi bi-cup-hot-fill me-2"></i>
                Où dormir ?
            </h1>
            <ul>
                <li>Des tipis (6 lits individuels par tipi) seront mis à disposition par le Château pour dormir sur
                    place</li>
                <li>Plusieurs hôtels sont à disposition dans les alentours du Château</li>
                <ul>
                    <li>à 800m : Hotel La Clé</li>
                    <li>à 3km : Logis hotel le vieux moulin</li>
                    <li>...</li>
                </ul>
                <li>Des gites et chambres d’hotes sont aussi à disposition à Gignac, Saint André de Sangonis et Clermont
                    l’Hérault</li>
            </ul>
        </div>
    </div>
</div>